import { col } from "framer-motion/client";
import BaseListPresenter from "../../../base/BaseListPresenter";

import { dialog } from "../../../nq-component";
import { saveObjectUseCase } from "../../../usecases/object";
import { liveQueryUseCase } from "../../../usecases/livequery";
import { User } from "nq-js";

class QueueingListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.audio = new Audio("/ding.mp3");
  }

  init() {
    const user = this.view.getCurrentUser();
    this.limit = 20;
    this.where = {
      window: user?.window,
      status: "waiting",
    };
    this.search = {};
    this.filter = {};
    this.include = [""];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  componentDidMount() {
    this.init();
    // this.subscribe();
    this.startPolling();
    return this.getObjects();
  }

  // subscribe() {
  //   const query = {
  //     collection: "queue",
  //     where: {},
  //   };

  //   const insertSubscription = liveQueryUseCase().execute(query, "afterInsert");
  //   insertSubscription.on("create", (newProduct) => {
  //     console.warn("COUNTsss", newProduct);
  //     console.count("COUNT", newProduct);
  //     this.objects?.unshift(newProduct);
  //     console.log("real one", this.objects);

  //     this.view.setObjects(this.objects);
  //   });

  //   const updateSubscription = liveQueryUseCase().execute(query, "afterUpdate");
  //   updateSubscription.on("update", (updatedProduct) => {
  //     const index = this.objects?.findIndex(
  //       (obj) => obj.id === updatedProduct.id
  //     );
  //     if (index !== -1) {
  //       this.objects[index] = updatedProduct;

  //       this.view.setObjects(this.objects);
  //     }
  //   });

  //   const deleteSubscription = liveQueryUseCase().execute(query, "afterDelete");
  //   deleteSubscription.on("delete", (deletedProduct) => {
  //     this.objects = this.objects.filter((obj) => obj.id !== deletedProduct.id);
  //     this.view.setObjects(this.objects);
  //   });

  //   [insertSubscription, updateSubscription, deleteSubscription].forEach(
  //     (subscription) => {
  //       subscription.on("error", (error) => {
  //         console.error("Subscription error:", error);
  //       });
  //     }
  //   );
  // }

  startPolling() {
    this.pollingInterval = setInterval(() => {
      this.pollObjects();
    }, 3000);
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  async pollObjects() {
    const previousObjects = this.objects ? [...this.objects] : [];
    const collection = this.view.getCollectionName();
    const collection2 = "queueServing";
    const query = this.createQuery();

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);

      this.objects = objects;
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);

      if (previousObjects.length > 0 && this.objects) {
        const hasUpdates = this.detectChanges(previousObjects, this.objects);
        if (hasUpdates) {
          this.audio.play().catch((err) => {
            console.warn("Audio play blocked by browser or failed:", err);
          });
        }
      }
    } catch (error) {
      console.error("Polling error:", error);
    }
  }

  detectChanges(previousObjects, currentObjects) {
    if (previousObjects.length !== currentObjects.length) {
      return true;
    }

    for (let i = 0; i < currentObjects.length; i++) {
      const current = currentObjects[i];
      const previous = previousObjects.find((obj) => obj.id === current.id);

      if (!previous) {
        return true;
      }

      if (JSON.stringify(previous) !== JSON.stringify(current)) {
        return true;
      }
    }

    return false;
  }

  async onClickServe(object) {
    const collection = this.view.getCollectionName();
    try {
      //   const deleteResponse = await this.deleteObjectUseCase.execute(
      //     collection,
      //     object.id
      //   );

      object.status = "serving";

      await this.upsertUseCase.execute("queue", object);
      //   this.view.reload();
      this.reset();
      this.getObjects();
      this.change = {};
    } catch (error) {}
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  onClickEdit(empDetails) {
    this.view.navigateTo(`/admin/employees/form/${empDetails?.id}`);
  }

  async onClickUpdateStatus(empDetails) {
    const object = empDetails;
    const collection = this.view.getCollectionName();

    object.status =
      object?.status === "InActive"
        ? "Active"
        : empDetails.status === "Active"
        ? "InActive"
        : null;

    await this.upsertUseCase.execute(collection, object);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }

  async handleSubmit(formData, employee, coordinator) {
    const collection = "request";
    const status = "Pending";
    const data = { ...formData, employee, coordinator, status };

    data.attachmentArray = formData.attachment;

    delete data.attachment;

    const response = await this.upsertUseCase.execute(collection, data);

    if (response) {
      dialog.close();
      this.view.successModal();
    }
  }

  async onReset() {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const query = {
      collection,
      where: {
        window: user?.window,
        status: "serving",
      },
    };

    try {
      const servingObjects = await this.findObjectUseCase.execute(
        collection,
        query
      );

      if (servingObjects?.length) {
        for (const obj of servingObjects) {
          await this.deleteObjectUseCase.execute(collection, obj.id);
        }

        this.view.showSuccess("Successfully cleared your window");
      } else {
        this.view.showNote(
          "No Records Found",
          `There are no serving applicants under ${user?.window} to reset.`
        );
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }
}

export default QueueingListPresenter;
